import { styled } from '@acko-tech/building-blocks.ui.common';
import { AckoMainTheme } from '@acko-tech/building-blocks.ui.theme';

export const SearchContainer = styled.div`
  color: ${() => AckoMainTheme.colors.light.primary.n600};
  width: 100%;
  background: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #040222;
  height: 46px;
  border: 1px solid;
`;

export const Input = styled.input`
  width: 100%;
  background: white;
  border-radius: 8px;
  outline-style: none;
  border: none;
  font-weight: ${() => AckoMainTheme.typography.fonts.weight.C1};
  font-size: 0.9rem;

  @media screen and (max-width: 768px) {
    caret-color: transparent;
  }

  ::placeholder,
  ::-webkit-input-placeholder {
    color: rgb(91, 86, 117);
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5rem;
    opacity: 0.8;
  }
  :-ms-input-placeholder {
    font-style: normal;
    color: rgb(91, 86, 117);
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5rem;
    opacity: 0.8;
  }
`;

export const SearchIconContainer = styled.div`
  cursor: pointer;
  padding: 0 10px 0 20px;
  height: 20px;
`;

export const BackIconContainer = styled.div`
  cursor: pointer;
  padding: 4px 2px 0 15px;
`;

export const ClearIcon = styled.div`
  cursor: pointer;
  padding: 4px 15px 0 15px;
`;
